module.exports = __webpack_public_path__ + "static/media/logowhite.622c9705.png";